(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('PrintContentDetailController', PrintContentDetailController);
//    PrintContentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils',  'PrintContent'];
//
//    function PrintContentDetailController($scope, $rootScope, $stateParams, DataUtils,  PrintContent) {
//    	var vm = this;
//
//    	vm.printContent1 = [{code:'C01',description:'Mới', reason:'System allows to input reason if reason are “Mới” and “Điều chỉnh”',status:'1'},
//                           {code:'C02',description:'Điều chỉnh', reason:'System allows to input reason if reason are “Mới” and “Điều chỉnh”',status:'1'},
//                           {code:'C03',description:'Không đổi', reason:'System allows to input reason if reason are “Mới” and “Điều chỉnh”',status:'1'}];
//    	vm.printContent = vm.printContent1[0]

    PrintContentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'PrintContent'];

    function PrintContentDetailController($scope, $rootScope, $stateParams, DataUtils, entity, PrintContent) {
        var vm = this;

        vm.printContent = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.printContent.status == 1){
        	vm.printContent.statusName = 'Đang hoạt động'
        }else{
        	vm.printContent.statusname = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:printContentUpdate', function(event, result) {
            vm.printContent = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
